export function trimAndReturnUndefinedIfEmpty(value?: string) {
  if (!value) {
    return undefined
  }

  const trimmedValue = value.trim()

  if (trimmedValue === '') {
    return undefined
  }

  return trimmedValue
}
